import React from 'react'

export const BackIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 17" fill="currentColor">
            <path d="M14.8021 8.67914L0.802124 8.67914M0.802124 8.67914L7.80212 15.6791M0.802124 8.67914L7.80212 1.67914"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
